// src/ui/theme/styleDefaults.js
// Valores POR DEFECTO reales de los slots editables del editor de estilos.
// Sirven para 3 cosas:
//   1) miniatura SIEMPRE visible de la imagen actual (aunque no haya override),
//   2) placeholder real en los inputs de texto (el texto que va de verdad),
//   3) que los espejos muestren el contenido real cuando no hay override.
//
// Imagenes: import directo del asset (misma fuente que la app).
// Textos: CLAVE i18n (ns:key); el editor la resuelve con i18next, asi el
// placeholder respeta idioma y no duplica strings.
import logoFull from "../../assets/png/Educa360Logo.png";
import logoIcon from "../../assets/png/icoeduca360.png";
import paso1 from "../../assets/illustrations/guia-catalogo/paso1.png";
import paso2 from "../../assets/illustrations/guia-catalogo/paso2.png";
import paso3 from "../../assets/illustrations/guia-catalogo/paso3.png";
import asis1 from "../../assets/illustrations/guia-asistentes/paso1.png";
import asis2 from "../../assets/illustrations/guia-asistentes/paso2.png";
import asis3 from "../../assets/illustrations/guia-asistentes/paso3.png";
import quiz1 from "../../assets/illustrations/guia-quiz/paso1.png";
import quiz2 from "../../assets/illustrations/guia-quiz/paso2.png";
import quiz3 from "../../assets/illustrations/guia-quiz/paso3.png";
import eval1 from "../../assets/illustrations/guia-evaluacion/paso1.png";
import eval2 from "../../assets/illustrations/guia-evaluacion/paso2.png";
import eval3 from "../../assets/illustrations/guia-evaluacion/paso3.png";
import tarea1 from "../../assets/illustrations/guia-tareas/paso1.png";
import tarea2 from "../../assets/illustrations/guia-tareas/paso2.png";
import tarea3 from "../../assets/illustrations/guia-tareas/paso3.png";
import tarea4 from "../../assets/illustrations/guia-tareas/paso4.png";
import tarea5 from "../../assets/illustrations/guia-tareas/paso5.png";
import vsc1 from "../../assets/illustrations/guia-vscenes/paso1.png";
import vsc2 from "../../assets/illustrations/guia-vscenes/paso2.png";
import vsc3 from "../../assets/illustrations/guia-vscenes/paso3.png";
import iconHumanas from "../../assets/categorias/ciencias-humanas.png";
import iconNaturales from "../../assets/categorias/ciencias-naturales.png";
import iconHistoria from "../../assets/categorias/historia.png";
import iconMatematicas from "../../assets/categorias/matematicas.png";
import iconArte from "../../assets/categorias/arte.png";
import iconVida from "../../assets/categorias/vida-saludable.png";
import { getCategoryColor } from "./categoryColors";

// Portada generica de itinerario (no hay banner por ruta). Misma URL que RouteCard.
const ITINERARIO_COVER =
  "https://storage.googleapis.com/educa360-legacy-assets/legacy/repopublic-educa360-central/adminweb/virtualscenes/PubliEduca360/Itinerario/1754473963925_itinerarioB.jpg";

// token de imagen -> asset por defecto actual
export const DEFAULT_IMAGES = {
  "image.logo.full": logoFull,
  "image.logo.icon": logoIcon,
  "image.salas.guide.step1": paso1,
  "image.salas.guide.step2": paso2,
  "image.salas.guide.step3": paso3,
  "image.assistant.guide.step1": asis1,
  "image.assistant.guide.step2": asis2,
  "image.assistant.guide.step3": asis3,
  "image.quiz.guide.step1": quiz1,
  "image.quiz.guide.step2": quiz2,
  "image.quiz.guide.step3": quiz3,
  "image.evaluacion.guide.step1": eval1,
  "image.evaluacion.guide.step2": eval2,
  "image.evaluacion.guide.step3": eval3,
  "image.itinerario.cover": ITINERARIO_COVER,
  "image.tareas.guide.step1": tarea1,
  "image.tareas.guide.step2": tarea2,
  "image.tareas.guide.step3": tarea3,
  "image.tareas.guide.step4": tarea4,
  "image.tareas.guide.step5": tarea5,
  "image.vscenes.guide.step1": vsc1,
  "image.vscenes.guide.step2": vsc2,
  "image.vscenes.guide.step3": vsc3,
  "image.salas.cat.humanas": iconHumanas,
  "image.salas.cat.naturales": iconNaturales,
  "image.salas.cat.historia": iconHistoria,
  "image.salas.cat.matematicas": iconMatematicas,
  "image.salas.cat.arte": iconArte,
  "image.salas.cat.vida": iconVida,
};

// token de texto -> clave i18n (ns:key) del texto por defecto real.
// Solo claves GLOBALES o de slot UNICO (namespaced por pagina). Los slots
// genericos (pageTitle/pageDescription) van en SCOPE_TEXT_DEFAULTS porque su
// defecto depende de la pagina.
export const DEFAULT_TEXT_KEYS = {
  // Nombres del menu lateral (misma fuente que navConfig)
  "text.nav.scenes": "common:nav.scenes",
  "text.nav.aiAssistants": "common:nav.aiAssistants",
  "text.nav.evaluations": "common:nav.evaluations",
  "text.nav.itineraries": "common:nav.itineraries",
  "text.nav.tasks": "common:nav.tasks",
  "text.nav.educamaker": "common:nav.educamaker",
  // Guia rapida de Salas
  "text.salas.guide.title": "common:quickGuide",
  "text.salas.guide.step1.title": "scenes:catalog.step1Title",
  "text.salas.guide.step1.desc": "scenes:catalog.step1Desc",
  "text.salas.guide.step2.title": "scenes:catalog.step2Title",
  "text.salas.guide.step2.desc": "scenes:catalog.step2Desc",
  "text.salas.guide.step3.title": "scenes:catalog.step3Title",
  "text.salas.guide.step3.desc": "scenes:catalog.step3Desc",
  // Guia rapida de Asistentes
  "text.assistant.guide.title": "common:quickGuide",
  "text.assistant.guide.step1.title": "assistants:page.step1Title",
  "text.assistant.guide.step1.desc": "assistants:page.step1Desc",
  "text.assistant.guide.step2.title": "assistants:page.step2Title",
  "text.assistant.guide.step2.desc": "assistants:page.step2Desc",
  "text.assistant.guide.step3.title": "assistants:page.step3Title",
  "text.assistant.guide.step3.desc": "assistants:page.step3Desc",
  // Guia rapida de Evaluaciones
  "text.quiz.guide.title": "common:quickGuide",
  "text.quiz.guide.step1.title": "teachers:pages.quizStep1",
  "text.quiz.guide.step1.desc": "teachers:pages.quizStep1Desc",
  "text.quiz.guide.step2.title": "teachers:pages.quizStep2",
  "text.quiz.guide.step2.desc": "teachers:pages.quizStep2Desc",
  "text.quiz.guide.step3.title": "teachers:pages.quizStep3",
  "text.quiz.guide.step3.desc": "teachers:pages.quizStep3Desc",
  // Guia rapida de Itinerarios
  "text.evaluacion.guide.title": "common:quickGuide",
  "text.evaluacion.guide.step1.title": "teachers:pages.evaluacionStep1",
  "text.evaluacion.guide.step1.desc": "teachers:pages.evaluacionStep1Desc",
  "text.evaluacion.guide.step2.title": "teachers:pages.evaluacionStep2",
  "text.evaluacion.guide.step2.desc": "teachers:pages.evaluacionStep2Desc",
  "text.evaluacion.guide.step3.title": "teachers:pages.evaluacionStep3",
  "text.evaluacion.guide.step3.desc": "teachers:pages.evaluacionStep3Desc",
  // Guia rapida de Tareas (5 pasos)
  "text.tareas.guide.title": "common:quickGuide",
  "text.tareas.guide.step1.title": "teachers:pages.tareasStep1",
  "text.tareas.guide.step1.desc": "teachers:pages.tareasStep1Desc",
  "text.tareas.guide.step2.title": "teachers:pages.tareasStep2",
  "text.tareas.guide.step2.desc": "teachers:pages.tareasStep2Desc",
  "text.tareas.guide.step3.title": "teachers:pages.tareasStep3",
  "text.tareas.guide.step3.desc": "teachers:pages.tareasStep3Desc",
  "text.tareas.guide.step4.title": "teachers:pages.tareasStep4",
  "text.tareas.guide.step4.desc": "teachers:pages.tareasStep4Desc",
  "text.tareas.guide.step5.title": "teachers:pages.tareasStep5",
  "text.tareas.guide.step5.desc": "teachers:pages.tareasStep5Desc",
  // Guia rapida de Educamaker (Mis escenas)
  "text.vscenes.guide.title": "common:quickGuide",
  "text.vscenes.guide.step1.title": "scenes:page.step1Title",
  "text.vscenes.guide.step1.desc": "scenes:page.step1Desc",
  "text.vscenes.guide.step2.title": "scenes:page.step2Title",
  "text.vscenes.guide.step2.desc": "scenes:page.step2Desc",
  "text.vscenes.guide.step3.title": "scenes:page.step3Title",
  "text.vscenes.guide.step3.desc": "scenes:page.step3Desc",
};

// Defecto de los slots GENERICOS por ambito (pagina). El nombre del titulo/
// descripcion de pagina cambia segun la pantalla.
export const SCOPE_TEXT_DEFAULTS = {
  "teacher/salas": {
    "text.pageTitle": "scenes:catalog.pageTitle",
    "text.pageDescription": "scenes:catalog.pageDesc",
  },
  "teacher/assistant": {
    "text.pageTitle": "assistants:page.title",
    "text.pageDescription": "assistants:page.subtitle",
  },
  "teacher/quiz": {
    "text.pageTitle": "teachers:pages.quizTitle",
    "text.pageDescription": "teachers:pages.quizDesc",
  },
  "teacher/evaluacion": {
    "text.pageTitle": "teachers:pages.evaluacionTitle",
    "text.pageDescription": "teachers:pages.evaluacionDesc",
  },
  "teacher/tareas": {
    "text.pageTitle": "teachers:pages.tareasTitle",
    "text.pageDescription": "teachers:pages.tareasDesc",
  },
  "teacher/educamaker": {
    "text.pageTitle": "scenes:page.title",
    "text.pageDescription": "scenes:page.description",
  },
};

// Tiles de categoria para el espejo: color del PUNTO = programatico (fuente
// unica, NO editable); el ICONO si es editable (slot de imagen).
export const CATEGORY_TILES = [
  { key: "todas", label: "TODAS", color: "#64748b", slot: null },
  {
    key: "humanas",
    label: "CIENCIAS HUMANAS",
    color: getCategoryColor("CIENCIAS HUMANAS"),
    slot: "image.salas.cat.humanas",
  },
  {
    key: "historia",
    label: "HISTORIA",
    color: getCategoryColor("HISTORIA"),
    slot: "image.salas.cat.historia",
  },
  {
    key: "matematicas",
    label: "MATEMATICAS",
    color: getCategoryColor("MATEMATICAS"),
    slot: "image.salas.cat.matematicas",
  },
  {
    key: "arte",
    label: "ARTE",
    color: getCategoryColor("ARTE"),
    slot: "image.salas.cat.arte",
  },
];

export default DEFAULT_IMAGES;
